import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { applyLayout } from "@/lib/layoutPrefs";

// Apply persisted layout preferences (accent colour, table density) before
// the first paint so there's no flash of default styles.
applyLayout();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// Note: React.StrictMode intentionally disabled because react-leaflet 4.x
// double-mounts MapContainer under strict mode causing "Map container is already initialized".
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
